// extracted by mini-css-extract-plugin
export default {"cashon":"Cash_cashon__wzf3D","cardon":"Cash_cardon__Z2BrE","ordernow":"Cash_ordernow__o6Sxb"};